<template>
  <div class="payment-form-flat">
    <form id="payment-form" action="/charge" method="post">
      <div class="stripe-form">
        <div ref="card-element" class="card-element">
          <!-- Stripe Element will be inserted here. -->
        </div>

        <!-- Used to display Element errors. -->
        <div id="card-errors" role="alert"></div>
      </div>
    </form>
  </div>
</template>

<script>
import { createToken } from 'vue-stripe-elements-plus'
import { stripeCard } from '@/services/stripe'

export default {
  name: 'PaymentFormFlat',
  data() {
    return {}
  },
  mounted: function() {
    // Within mounted hook because we mount stripeCard element after DOM has been loaded
    stripeCard.mount(this.$refs['card-element'])

    stripeCard.addEventListener('change', ({ error }) => {
      const displayError = document.getElementById('card-errors')
      if (error) {
        displayError.textContent = error.message
        this.complete = false
      } else {
        displayError.textContent = ''
        this.complete = true
      }
      this.$emit('change', {
        stripeCard: stripeCard,
        complete: this.complete,
      })
    })
  },
  watch: {
    '$language.current': function updateCardFormWithLanuage() {
      // Within mounted hook because we mount stripeCard element after DOM has been loaded
      stripeCard.mount(this.$refs['card-element'])

      stripeCard.addEventListener('change', ({ error }) => {
        const displayError = document.getElementById('card-errors')
        if (error) {
          displayError.textContent = error.message
          this.complete = false
        } else {
          displayError.textContent = ''
          this.complete = true
        }
        this.$emit('change', {
          stripeCard: stripeCard,
          complete: this.complete,
        })
      })
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
.is-centered {
  display: flex;
  justify-content: center;
}
.card-element {
  border-bottom: 1px solid $gray;
  padding: 0.5rem 0;
}
#card-errors {
  padding-top: 0.5rem;
  color: #fa755a;
}
</style>
